import axios from "axios";

const BASE = "/api";

export async function startUpload(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${BASE}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data; // { job_id }
}

export async function pollJob(jobId) {
  const res = await axios.get(`${BASE}/job/${jobId}`);
  return res.data; // { status, result, error }
}

export async function getDistricts() {
  const res = await axios.get(`${BASE}/districts`);
  return res.data.districts;
}

export async function downloadReport(format, payload) {
  const res = await axios.post(`${BASE}/report/${format}`, payload, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `poshan_report.${format === "excel" ? "xlsx" : "pdf"}`;
  a.click();
  URL.revokeObjectURL(url);
}
